<v-dialog v-model="valueSync" persistent :width="width">
    <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
            <h3 class="ps-2">{{ label }}</h3>
            <v-btn @click="close" icon="mdi-close" variant="plain"></v-btn>
        </v-card-title>
        <v-card-text><slot></slot></v-card-text>
    </v-card>
</v-dialog>